<template>
    <v-card elevation="5" class="overflow-y-auto">
        <v-card-title class="d-flex">
            <v-row dense>
                <v-col cols="12" md="5">
                    <div
                        v-if="$vuetify.breakpoint.smAndDown"
                        class="grey--text text-overline ml-2 text-center"
                    >
                        {{ video.title }}
                    </div>
                    <div
                        v-else
                        class="font-weight-light grey--text text-h5 ml-2"
                    >
                        {{ capitalize(video.title) }}
                    </div>
                </v-col>
                <v-col cols="12" md="7">
                    <div
                        :class="
                            $vuetify.breakpoint.smAndDown
                                ? 'd-flex justify-center'
                                : 'd-flex justify-end'
                        "
                    >
                        <div>
                            <v-btn
                                fab
                                x-small
                                color="red"
                                outlined
                                class="backFlipBtn"
                                @click="updateValue(false)"
                            >
                                <v-icon> mdi-axis-z-rotate-clockwise </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-title>
        <!-- <v-divider class="mb-4"></v-divider> -->
        <v-card-text>
            <div id="video-content" class="d-flex justify-center">
                <iframe
                    frameborder="0"
                    border="0"
                    cellspacing="0"
                    style="border-style: none; border-radius: 10px;"
                    width="600px"
                    allow="fullscreen"
                    height="320px"
                    :src="video.url"
                >
                </iframe>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { clone } from '@/util/libUtil.js';
import { formatDateLarge } from '@/util/libUtil.js';

export default {
    props: {
        video: Object,
    },
    name: 'VideoBackCard',
    methods: {
        formatDateLarge,
        updateValue: function (value) {
            this.$emit('input', value);
        },
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
    },
};
</script>